"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.State = void 0;
var create_entity_1 = require("../../utils/create-entity");
var gql = String.raw;
exports.State = {
  name: 'State',
  type: 'taxonomy',
  autoRoutes: ['list', 'create', 'update'],
  useSlices: true,
  table: {
    fieldNames: ["name", "country"]
  },
  filters: {
    fields: {
      country: {
        entityTypeName: 'Economy'
      }
    }
  },
  list: {
    queryFields: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      country {\n        id slug name _optionLabel iso shorthand openGraph { id image { id url } }\n      }\n    "], ["\n      country {\n        id slug name _optionLabel iso shorthand openGraph { id image { id url } }\n      }\n    "])))
  },
  update: {
    queryFields: gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      abbr\n      country {\n        id slug name _optionLabel iso shorthand openGraph { id image { id url } }\n      }\n    "], ["\n      abbr\n      country {\n        id slug name _optionLabel iso shorthand openGraph { id image { id url } }\n      }\n    "])))
  },
  form: {
    fields: __assign(__assign({}, create_entity_1.entityStandardFormFields), {
      abbr: {
        type: 'text',
        maxWidth: '400px'
      },
      country: {
        type: 'linked',
        entityTypeName: 'Economy'
      }
    })
  }
};
var templateObject_1, templateObject_2;